import { isGenericPromptInstructionType } from './const';

/**
 * Compares a "placeholder" with an "instruction" to determine if they match.
 * @param {Object} placeholder
 * @param {Object} instruction
 * @returns {boolean} - Returns "true" if the placeholder matches the instruction, "false" otherwise.
 */
export const comparePlaceholderAndInstruction = (placeholder, instruction) => {
  if (!placeholder || !instruction) {
    return false;
  }

  if (placeholder.instructionType !== instruction.type) {
    return false;
  }

  // For generic prompt instructions, compare the instruction text
  if (isGenericPromptInstructionType(placeholder.instructionType)) {
    return placeholder.instruction === instruction.text;
  }

  // For other types, compare the ID
  return placeholder.id === instruction.id;
};
